<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<div class="page-indicator">
    <div *ngIf="serviceFlag && claimsDataService.lossCauseTypesLoaded" class="claims-track-page-title-wrap claims-track-page-title--overview">
        Claim Overview
        <small class="claims-track-company">
            <strong style="text-transform: uppercase;">{{claimsDataService.getLossCause(claimInfo.lossCause)}}</strong>
            ({{claimInfo.claimNumber}})
            <strong style="text-transform: uppercase;">{{claimInfo.claimState}}</strong>
            <span *ngIf="claimInfo.incidentOnly">(Record Only)</span>
        </small>
        <small class="claims-track-number">Incident date: {{claimInfo.lossDate| date:'MM/dd/yyyy'}}</small>
    </div>
</div>

<div class="content-container-light-blue bolt-space-bottom-sm">
    <main class="content-container-light-blue__inner" role="main">
        <article>
            <h2 style="margin-bottom:5px;font-weight:bold;font-size:1.15em;text-transform:uppercase;">Recent Update</h2>
            <a (click)="navigateToAllUpdates()" title="See All Updates" class="cta-txt-link link-arrow-orange" style="float:right;margin-top: -25px;">See
                All Updates</a>
            <div *ngIf="count>0" class="claims-track-claim-content__text-box">
                <div class="mat-icon-container">
                    <mat-icon svgIcon="claim"></mat-icon>
                </div>
                <div class="flexing">
                    <em class="claims-track-claim-recent-update-headline">{{claimEventsFiltered.eventName}}
                        {{claimEventsFiltered.eventDate|
                        date:'MM/dd/yyyy'}}
                    </em>
                    <a (click)="checkFlow()" title="See Details" class="link-arrow-orange js-see-details" style="margin-bottom: 5px; margin-left: 5px; display: inline-block;">See
                        Details
                    </a>
                    <br>{{claimEventsFiltered.eventDescription}}
                </div>
            </div>
        </article>
        <article *ngIf="serviceFlag">
            <div class="claims-track-claim-content__text-box">
                <div class="mat-icon-container">
                    <mat-icon svgIcon="representative"></mat-icon>
                </div>
                <div class="flexing">
                    <p class="claims-track-claim-rep-info">Claims representative:</p>
                    <p class="claims-track-claim-rep-info" style="margin: 0;">
                        <em>{{claimInfo.adjuster.displayName}}</em>
                        <br>
                        <a href="tel:{{claimInfo.adjuster.phoneNumber}}" title="{{claimInfo.adjuster.phoneNumber}}">{{claimInfo.adjuster.phoneNumber}}</a>
                        <br>
                        <a href="mailto:{{claimInfo.adjuster.email}}" title="{{claimInfo.adjuster.email}}">
                            <em>{{claimInfo.adjuster.email}}</em>
                        </a>
                    </p>
                </div>
            </div>
        </article>


        <article class="claims-overview-content">
            <h2>Details</h2>
            <a (click)="navigateToIncidentDetails()" title="Details & Documents" class="claims-track-claim-content__link-box link-arrow-orange dark-gray-text">
                <span class="claims-overview-details">Incident details</span>

                <div class="mat-icon-container">
                    <mat-icon svgIcon="incident-details"></mat-icon>
                </div>
            </a>
            <a *ngIf="(contactsOnly$ | async) === 'true'" (click)="navigateToClaimContacts()" title="Claim Contacts" class="claims-track-claim-content__link-box link-arrow-orange dark-gray-text">
                <span class="claims-overview-details">Claim contacts</span>
                <div class="mat-icon-container">
                    <mat-icon svgIcon="contacts"></mat-icon>
                </div>
            </a>
            <a *ngIf="(paymentsOnly$ | async) === 'true'" (click)="navigateToPayments()" title="Payments" class="claims-track-claim-content__link-box link-arrow-orange dark-gray-text">
                <span class="claims-overview-details">Payments</span>
                <div class="mat-icon-container">
                    <mat-icon svgIcon="payments"></mat-icon>
                </div>
            </a>
        </article>
    </main>
</div>
<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
